<p-dialog
    header="Create Branch"
    [(visible)]="visible"
    [modal]="true"
    [style]="{ width: '500px' }"
    [closable]="true"
    [draggable]="false"
    (onShow)="onShow()"
    (onHide)="onHide()"
>
    <div class="flex flex-column h-5 justify-content-start">
        <div class="padding-px-24 padding-py-16">
            <span class="p-float-label mb-3 mt-3 w-full">
                <input
                    id="branchName"
                    type="text"
                    pInputText
                    [(ngModel)]="branchName"
                    [disabled]="loading()"
                    class="w-full height-40"
                    [ngClass]="{ 'ng-invalid ng-dirty': branchNameError }"
                />
                <label for="branchName">Branch Name</label>
            </span>
            @if (branchNameError) {
                <small class="text-red-500 block -mt-2 mb-3">{{ branchNameError }}</small>
            }

            <span class="p-float-label mt-3 w-full">
                <p-dropdown
                    id="parentBranch"
                    [options]="parentBranchOptions()"
                    [(ngModel)]="selectedParentBranch"
                    [disabled]="loading()"
                    [filter]="true"
                    filterPlaceholder="Search"
                    styleClass="w-full height-40"
                    appendTo="body"
                />
                <label for="parentBranch">Parent Branch</label>
            </span>
        </div>
        <div class="flex gap-12 padding-px-24 padding-py-16">
            <p-button
                styleClass="height-44 shadow-none"
                [text]="true"
                label="Cancel"
                [disabled]="loading()"
                (onClick)="onCancel()"
            ></p-button>
            <span class="flex-1"></span>
            <p-button
                styleClass="height-44"
                [outlined]="true"
                label="Create"
                [disabled]="!isValid || loading()"
                (onClick)="onCreate()"
            ></p-button>
            <p-button
                styleClass="height-44"
                label="Create & Checkout"
                [disabled]="!isValid || loading()"
                [loading]="loading()"
                (onClick)="onCreateAndCheckout()"
            ></p-button>
        </div>
    </div>
</p-dialog>
